import React, { Component } from 'react';


import {Modal, Grid, Row, Col} from 'react-bootstrap';
import ReactDOM from 'react-dom';
import Switch from "react-switch";

class News extends Component {
  constructor(props, context) {
    super(props, context);
    this.showVideoInModal = this.showVideoInModal.bind(this);
    this.handleToggleSwitch = this.handleToggleSwitch.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.state = {
      left: "newsLeft inview",
      right: 'newsRight',
      videopath: '',
      show: false,
      hq: false
    };
  }

  handleClose() {
    this.setState({ show: false });
  }

  handleToggleSwitch(checked) {
    this.setState({ hq: checked });
  }


  toggleInview() {
    if (this.state.left === "newsLeft") {
      this.setState({ left: "newsLeft inview" });
      this.setState({ right: "newsRight" });
    } else {
      this.setState({ left: "newsLeft" });
      this.setState({ right: "newsRight inview" });
    }
  }

  toggleInviewGridLeft() {
    if (this.state.left === "newsLeft") {
      this.setState({ left: "newsLeft inview" });
      this.setState({ right: "newsRight" });
    }
  }

  toggleInviewGridRight() {
    if (this.state.right === "newsRight") {
      this.setState({ left: "newsLeft" });
      this.setState({ right: "newsRight inview" });
    }
  }

  showVideoInModal(path){
    if (this.state.right === "newsRight inview") {
      if (this.state.hq === true) {
        this.setState({videopath: '../videos/hq_' + path});
        this.setState({show: true});
      }else{
        this.setState({videopath: '../videos/' + path});
        this.setState({show: true});
      }
    }
  }

  render() {

    var dataNews;
    var dataVideo;
    var builtTmpNews;
    var builtTmpVideos;
    var parseString = require('xml2js').parseString;
      fetch('/newsData.xml')
      .then((r) => r.text())
      .then(text  => {
        parseString(text, function (err, result) {
            dataNews=result;
            var tmpOV = JSON.parse(JSON.stringify(result));
            dataNews= tmpOV.NewsList.News;
            builtTmpNews = dataNews.map((element) =>
                  <Col xs={12} sm={6} md={4} lg={4} className="newsItem">
                    <div className="newsCont">
                    <img src={`../news/${element.Image}`} alt={element.Title} className={`newsImg${element.classType}`} />
                    <video id="background-video" className={`newsVideo${element.classType}`} loop autoPlay playsinline="true" onClick={() => {
                        this.showVideoInModal(element.File);
                      }}>
                        <source src={`../videos/${element.FileShort}`} type="video/mp4" />
                        Your browser does not support the video tag.
                      </video>
                      <hr/>
                      <h4>{element.Title}</h4>
                      <h5>{element.Supplier}</h5>
                      <hr/>
                      <p className="newsText">{element.Text}</p>
                      <hr/>
                      <p className="newsDate">{element.Date}</p>
                    </div>
                  </Col>

                );
          }.bind(this));
          this.builtElement = ReactDOM.render(builtTmpNews, document.getElementById('newsRoot'));
      });



    return (
        <div className='container-fluid newsMain'>
            <h1 className="titleNews" onClick={this.toggleInview.bind(this)}><span>News & Videos</span></h1>
            <Grid class="newsGrid" onClick={this.toggleInviewGridLeft.bind(this)}>
              <Row id="newsRoot" className='container-fluid'/>
            </Grid>
          <Modal show={this.state.show} onHide={this.handleClose}>
            <Modal.Body className="videoModal" closeButton>
              <video className='videoNewsModal' controls autoplay>
                <source src={this.state.videopath} type="video/mp4"/>
                Your browser does not support the video tag.
              </video>
            </Modal.Body>
          </Modal>
        </div>
    );
  }
}

export default News;



// WEBPACK FOOTER //
// ./src/components/pages/news.js